import script from "./ClientPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientPreview.vue?vue&type=script&setup=true&lang=js"

import "./ClientPreview.vue?vue&type=style&index=0&id=b5f0d4c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5f0d4c8"]])

export default __exports__